import { ReactNode } from 'react';
import { BaseIssue } from 'valibot';

import {
	Autocomplete,
	FormHelperText,
	SxProps,
	TextField,
} from '@mui/material';
import { Theme } from '@mui/material/styles';

import { useFieldContext } from '#form';

import { LabelInput } from '@repo/ui/LabelInput';

interface InputProps {
	label: ReactNode;
	sx?: SxProps<Theme>;
	options: Array<string | number>;
	optionLabels: string[];
	disabled?: boolean;
}

export function SelectInput({
	label,
	options,
	optionLabels,
	sx,
	disabled,
}: InputProps) {
	const field = useFieldContext<string | number | null>();
	const error = (
		field.state.meta as {
			errors?: Array<string | BaseIssue<unknown>>;
		}
	).errors?.[0];

	return (
		<LabelInput label={label} fieldName={field.name}>
			<Autocomplete
				id={field.name}
				value={field.state.value ?? ''}
				disabled={disabled}
				options={options}
				getOptionLabel={(option) => {
					const index = options.indexOf(option);
					return optionLabels[index] ?? '';
				}}
				onBlur={() => {
					if (typeof field.state.value === 'string') {
						field.handleChange(field.state.value.trim());
					}
					field.handleBlur();
				}}
				onChange={(_, newValue) => {
					field.handleChange(newValue);
				}}
				sx={sx}
				renderInput={(params) => (
					<TextField
						name={field.name}
						variant="outlined"
						{...params}
						error={error != null}
						slotProps={{
							htmlInput: { ...params.inputProps, readOnly: true },
						}}
					/>
				)}
			/>
			{error != null && (
				<FormHelperText error>
					{typeof error === 'string' ? error : error.message}
				</FormHelperText>
			)}
		</LabelInput>
	);
}
